var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoBack = function SvgGoBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 11,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 20a.853.853 0 0 0-.852-.852H13.462l4.386-4.527a.85.85 0 0 0-.031-1.206.853.853 0 0 0-1.205.032l-5.753 5.966a.853.853 0 0 0 0 1.174l5.753 5.966a.853.853 0 0 0 1.236-1.174l-4.386-4.527h15.06c.471 0 .853-.381.853-.852Z",
    fill: "#282828"
  })));
};

export default SvgGoBack;